// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_MinutaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /contratos/minuta_salvar (Full). minuta_id 0 = minuta nova, copiada do modelo vigente
 * (clausulas vazias) ou já com as cláusulas mandadas. pedido é o que se pediu à IA, guardado.
 */
import type { Contratos_ClausulaRow } from './Contratos_ClausulaRow'
import { registerContract } from './validate'

export interface Contratos_MinutaInput {
franquia_id?: number
minuta_id?: number
pedido?: string
clausulas?: Contratos_ClausulaRow[]
}

registerContract('Contratos_MinutaInput', {
  franquia_id: { type: 'number',  required: false },
  minuta_id:   { type: 'number',  required: false },
  pedido:      { type: 'string',  required: false },
  clausulas: {
    type: 'array',
    required: false,
    items: {
      chave:  { type: 'string',  required: false },
      titulo: { type: 'string',  required: false },
      texto:  { type: 'string',  required: false },
      fixa:   { type: 'boolean', required: false },
    },
  },
})
